import React from 'react';
import { string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ carrier: Validator<string>; }' is missing ... Remove this comment to see the full error message
class PreventativeCarePaysOff extends Base {
  static propTypes = {
    carrier: string.isRequired,
  };

  static isVisible = () => true;

  icon = '/images/insurance_tutorial/04_preventative.svg';

  render = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'carrier' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { carrier } = this.props;
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Preventative care pays off</H2>

            <P>
              If you think about it, it’s actually in <b>{carrier}’s</b> best interest for you to
              stay healthy. That’s why they make some preventative services available for little to
              no cost.
            </P>

            <P>
              Case in point: your plan includes a <b>free annual physical</b>.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default PreventativeCarePaysOff;
